"use client"

import { PencilOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PencilOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PencilOffIcon = component(Icon)({ as: PencilOff })
